<template>
  <Section
    :breadCrumbs="breadCrumbs"
    @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
    v-bind="$attrs"
    :shouldShowSearch="shouldShowSearch"
    :title="title"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    icon="event"
    :isLoading="isLoading"
  >
    <template v-slot:toolbarExtension>
      <v-layout row wrap justify-space-between subheading>
        <v-flex shrink>
          <div v-if="activityDetail.locationId">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>place</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: locationList,
                      idKey: "id",
                      idValue: activityDetail.locationId,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Location</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>schedule</v-icon>
                  {{
                    _formatJavascriptDate({
                      date: activityDetail.dateTimePerformedOn,
                    })
                  }}
                </span>
              </template>
              <span>Performed On</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex shrink text-xs-left text-sm-right>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>face</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: userList,
                      idKey: "id",
                      idValue: activityDetail.userIdPerformedBy,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Performed By</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs12 v-if="activityDetail.comments">
          <v-icon>comment</v-icon>
          {{ activityDetail.comments }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import SectionContainerPage from '../../../../common/components/layouts/SectionContainerPage'

export default {
  inheritAttrs: false,
  components: {
    Section,
    SectionContainerPage,
  },
  mixins: [mixinAssetHelper],
  props: {
    breadCrumbs: Array,
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    title: {
      type: String,
    },
    shouldShowSearch: {
      type: Boolean,
    },
    activityDetail: {
      type: Object,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    clientList: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>
